<template>
    <div>
       
        <div v-if="showLoader" class="wrapper-child">
            <img src="/assets/img/loader/loaderImageHome.svg" />
            <p>لطفا منتظر بمانید...</p>
        </div>
        <div v-else>
            <!--<div v-if="!baseInfo.IsActiveOrder" class="arlt-pishtaz">
                <div class="close-alrt">
                    <div class="close close-alert"><i class="fa fa-close"></i></div>
                    <div><span><span class="alert-d">توجه :</span> هیچ روش پرداختی فعال نیست ، بنابرین شما نمی توانید اقدام به تکمیل خرید نمایید.</span></div>
                </div>
            </div>-->
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar3-component></navbar3-component>
                </header>
                <!-- header -->
                <!-- main -->
                <component :is="cart == null ? 'cartEmpty': 'nonEmptyCart' "></component>
                <!-- main -->

                <div class="container" style="overflow:hidden">
                    <div class=" d-none d-sm-block">
                        <div class="ai-center-fr jc-between">
                            <a class="footer-features">
                                <div>
                                    <img class="ls-is-cached" alt="ضمانت اصالت" src="/assets/img/footer/ضمانت_اصالت.png">
                                </div>
                                <p class="text-caption color-700">ضمانت اصالت</p>
                            </a>
                            <a class="footer-features">
                                <div>
                                    <img class="ls-is-cached" alt="مناسب ترین قیمت" src="/assets/img/footer/مناسب_تر_قیمت.png">
                                </div>
                                <p class="text-caption color-700">مناسب ترین قیمت</p>
                            </a>
                            <a class="footer-features">
                                <div>
                                    <img class="ls-is-cached" alt="تحویل_سریع" src="/assets/img/footer/تحویل_سریع.png">
                                </div>
                                <p class="text-caption color-700">تحویل سریع</p>
                            </a>

                            <a class="footer-features">
                                <div>
                                    <img class="ls-is-cached" alt="امکان برگشت کالا" src="/assets/img/footer/بازگشت_کالا.png">
                                </div>
                                <p class="text-caption color-700">امکان برگشت کالا</p>
                            </a>
                        </div>
                    </div>
                </div>
                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>

        </div>
    </div>

</template>

<script>

    import { initialSite } from "../../module/initialSite";
    import cartEmpty from "./emptyCart.vue";
    import nonEmptyCart from "./nonEmptyCart.vue";

    export default {
        data() {
            return {
                showLoader: false
            }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        components: {
            'cartEmpty': cartEmpty,
            'nonEmptyCart': nonEmptyCart
        },
        beforeMount: function () {
            initialSite(this);
            createPageTitle('سبد خرید');
            this.scrollTop();
        },
        methods: {
            scrollTop() {
                $(function () {
                    $('html, body').scrollTop(0);
                });
            }
        }
    }
</script>

<style scoped>

    .ai-center-fr {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        margin-top: 40px;
    }

    .footer-features {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
    }

    .socials .footer-social a i {
        color: #c1af4e;
        font-size: 18px;
    }

    .margin {
        margin: 0 5px 0 5px;
    }

    .div-image {
        display: inline-block;
    }

    .text-all {
        font-size: 14px;
    }

    @media screen and (min-width: 1077px) {
        .cart-page {
            margin-top: 15px;
        }
    }
</style>